import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { customersSlice } from 'redux/slices/customers';
import { shopsSlice } from 'redux/slices/shops';

import { ordersApi } from './api/ordersApi';
import { constantsSlice } from './slices/constants';
import { ordersSlice } from './slices/orders';
import { querySlice } from './slices/query';
import { selectionsSlice } from './slices/selections';
import { settingsSlice } from './slices/settings';
import { statusesSlice } from './slices/statuses';
import { tableConfigSlice } from './slices/tableConfig';
import { userDataSlice } from './slices/userData';
import { usersDataSlice } from './slices/usersData';
import { warehousesSlice } from './slices/warehouse';

const combinedReducer = combineReducers({
  customers: customersSlice.reducer,
  shops: shopsSlice.reducer,
  constants: constantsSlice.reducer,
  warehouses: warehousesSlice.reducer,
  usersData: usersDataSlice.reducer,
  tableConfig: tableConfigSlice.reducer,
  userData: userDataSlice.reducer,
  statuses: statusesSlice.reducer,
  queries: querySlice.reducer,
  settings: settingsSlice.reducer,
  orders: ordersSlice.reducer,
  selections: selectionsSlice.reducer,
  [ordersApi.reducerPath]: ordersApi.reducer,
});

// eslint-disable-next-line
const rootReducer = (state: any, action: any) => {
  if (action.type === 'userData/logout') {
    state = undefined; // eslint-disable-line
  }
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(ordersApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store };
